import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TRANSACTIONS_QUERY_KEY } from "./useTransactions";
import { ANALYTICS_QUERY_KEY } from "./useSummary";

type UpdateTransactionBody = components["schemas"]["UpdateTransactionBody"];
type TransactionResponse = components["schemas"]["TransactionResponse"];

export type UpdateTransactionVariables = {
  transactionId: string;
  body: UpdateTransactionBody;
};

export function useUpdateTransaction() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<TransactionResponse, Error, UpdateTransactionVariables>({
    mutationFn: async ({ transactionId, body }) => {
      const { data, error } = await client.PATCH(
        "/api/transactions/{transaction_id}",
        {
          params: { path: { transaction_id: transactionId } },
          body,
        },
      );
      if (error !== undefined) {
        throw new Error(`Failed to update transaction ${transactionId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TRANSACTIONS_QUERY_KEY });
      void queryClient.invalidateQueries({ queryKey: ANALYTICS_QUERY_KEY });
    },
  });
}
